<template>
    <div class="flex w-full justify-center">
        <app-fieldset :label="$t('preparations.visas')" class="w-full">
            <div class="flex flex-col" v-if="!preparation.emissionDate">
                <label class="flex flex-col p-2 border">
                    <div class="flex">
                        <icon-pause-circle-outline class="mr-2 text-gray-400" />
                        <div class="flex justify-start">
                            {{ $t('administrativeFiles.legend.documentToEmit') }}
                        </div>
                    </div>
                </label>
            </div>

            <div class="flex flex-col" v-else-if="preparation.expireAt && preparation.expireAt.getTime() < Date.now()">
                <label class="flex flex-col p-2 border">
                    <div class="flex">
                        <icon-clock-alert-outline class="mr-2 text-red-700" />
                        <div class="flex justify-start">
                            {{ $t('administrativeFiles.legend.expired') }}
                        </div>
                    </div>
                    <app-tips class="font-normal text-left" style="grid-column: 2 / span 2">
                        {{ $t('administrativeFiles.legend.expiredTips') }}
                    </app-tips>
                </label>
            </div>
            <template v-else>
                <div class="w-full" v-if="visas[0]">
                    <app-separator
                        variant="underline"
                        :label="$t('preparations.visaMOE')"
                        class="w-full"
                    ></app-separator>
                    <administrative-visa-picker
                        v-model="visas[0].conclusion"
                        @input="save(visas[0])"
                        :disabled="!isAdmin && !isMOEEmitter"
                    />
                    <app-label :label="$t('administrativeFiles.visaComments')">
                        <app-textarea
                            v-model="visas[0].comments"
                            @blur="save(visas[0])"
                            :disabled="!isAdmin && !isMOEEmitter"
                        ></app-textarea>
                    </app-label>
                </div>
                <div class="w-full" v-if="visas[1]">
                    <app-separator
                        variant="underline"
                        :label="$t('preparations.visaMOA')"
                        class="w-full"
                    ></app-separator>
                    <administrative-visa-picker
                        v-model="visas[1].conclusion"
                        @input="save(visas[1])"
                        :disabled="!isAdmin && !isMOAEmitter"
                    />
                    <app-label :label="$t('administrativeFiles.visaComments')">
                        <app-textarea
                            v-model="visas[1].comments"
                            @blur="save(visas[1])"
                            :disabled="!isAdmin && !isMOAEmitter"
                        ></app-textarea>
                    </app-label>
                </div>
            </template>
        </app-fieldset>
    </div>
</template>

<script>
import {
    getPreparationVisasByPreparationId,
    updatePreparationVisa,
} from '@/features/preparations/preparationVisas.service';
import { combineLatest } from 'rxjs';
import { getProject } from '@/features/projects/projects.service';
import AppFieldset from '@/components/appFieldset/AppFieldset.vue';
import AppDateInput from '@/components/appDateInput/AppDateInput.vue';
import PreparationVisaPicker from '@/features/preparations/PreparationVisaPicker.vue';
import AppSaveOnLeave from '@/components/AppSaveOnLeave.vue';
import AdministrativeVisaPicker from '@/features/administrativeFiles/AdministrativeVisaPicker.vue';
import IconTimelapse from '@/icons/IconTimelapse.vue';
import IconClockAlertOutline from '@/icons/IconClockAlertOutline.vue';
import AppTips from '@/components/app-tips/AppTips.vue';
import { getPreparation } from '@/features/preparations/preparations.service';
import IconPauseCircleOutline from '@/icons/IconPauseCircleOutline.vue';
import AppSeparator from '@/components/appSeparator/AppSeparator.vue';
import AppTextarea from '@/components/app-textarea/AppTextarea.vue';
import AppLabel from '@/components/appLabel/AppLabel.vue';

export default {
    components: {
        AppLabel,
        AppTextarea,
        AppSeparator,
        IconPauseCircleOutline,
        AppTips,
        IconClockAlertOutline,
        IconTimelapse,
        AdministrativeVisaPicker,
        AppSaveOnLeave,
        PreparationVisaPicker,
        AppDateInput,
        AppFieldset,
    },
    created() {
        this.init();
    },
    watch: {
        $route: function () {
            this.init();
        },
    },
    data() {
        return {
            isAdmin: false,
            isMOEEmitter: false,
            isMOAEmitter: false,
            subscriptions: [],
            visas: [],
            preparation: {},
        };
    },
    methods: {
        init() {
            this.subscriptions = [
                combineLatest([
                    getProject(this.$route.params.projectId),
                    getPreparationVisasByPreparationId(this.$route.params.projectId, this.$route.params.preparationId),
                    getPreparation(this.$route.params.projectId, this.$route.params.preparationId),
                ]).subscribe(([project, visas, preparation]) => {
                    this.visas = visas;
                    this.preparation = preparation;
                    this.isMOEEmitter = !!project.me.bundleIds.find(
                        (bundleId) => this.visa[0] && this.visa[0].emitterId && bundleId === this.visa[0].emitterId,
                    );
                    this.isMOAEmitter = !!project.me.bundleIds.find(
                        (bundleId) => this.visa[1] && this.visa[1].emitterId && bundleId === this.visa[1].emitterId,
                    );
                    this.isAdmin = project.me.allowedFeatures.includes('project_administrativeFiles');
                }),
            ];
        },
        async save(visa) {
            await updatePreparationVisa(this.$route.params.projectId, {
                id: visa.id,
                emissionDate: visa.emissionDate || (visa.conclusion ? new Date() : null),
                conclusion: visa.conclusion || null,
                comments: visa.comments || null,
            });
        },
    },
};
</script>
